import { CONTENT_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForContentElement =
    createDisplayName(CONTENT_DISPLAY_NAME);
